import React, { useContext } from 'react';
const AppContext = /*#__PURE__*/React.createContext();
export default AppContext;
export const useAppContext = () => useContext(AppContext); //